export const ENV = process.env.NEXT_PUBLIC_ENV;
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_KEY;
export const RECAPTCHA_DEV_TOKEN = process.env.NEXT_PUBLIC_RECAPTCHA_DEV_TOKEN;
export const PYTHON_API = process.env.NEXT_PUBLIC_PYTHON_API;
export const RAILS_API = process.env.NEXT_PUBLIC_RAILS_API;
export const MAIN_APP_URL = process.env.NEXT_PUBLIC_MAIN_APP_URL;
export const GOOGLE_MAPS_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;
export const CANDIDATE_APP_URL = process.env.NEXT_PUBLIC_CANDIDATE_PORTAL_URL;
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
export const JOBS_URL = process.env.NEXT_PUBLIC_JOBS_URL;
export const SLACK_ERROR_URL = process.env.NEXT_PUBLIC_SLACK_ERROR_URL;
export const SSG_SLUGS = process.env.NEXT_PUBLIC_SSG_SLUGS;
